/* agdesk-back-to-top.js — "Go back to top" at the foot of the buy column.
 *
 * Dorian 2026-10-07: "make a nice and sober button on the bottom of this same
 * right part that labels 'Go back to top' and it goes back to the top both
 * for the left and right part".
 *
 * Desktop layout only (html.agdesk-on): there the page is two scrollers side
 * by side - the media pane (.agdesk-media) and the buy column - and after a
 * long read down either one, nothing brought both back. One press scrolls
 * BOTH to their tops (and the window, which holds only the tucked footer).
 *
 * WHERE IT SITS: the very last thing in the buy column, under the column-end
 * Add to cart (agmf-buy-tail.js) and the Ask card's anchor - that tail keeps
 * its own place just above this button (its "foot" exception). The column is
 * the one the product bridge names (`.product-info` on a standard page, the
 * outer `.agb-main` on a Gear Builder page), so it is the same column on both.
 *
 * The label is a theme locale key (agilite_panel.back_to_top), handed over by
 * the section as window.AGMF_BACK_TO_TOP.
 *
 * Own file; reads the DOM and the bridge, edits nothing upstream.
 */
(function () {
  'use strict';
  if (window.__agdeskBackToTop) return;
  window.__agdeskBackToTop = true;

  var root = document.documentElement;
  var wrap = null, watched = null, observer = null;

  function label() {
    var w = window.AGMF_BACK_TO_TOP;
    return (typeof w === 'string' && w.trim()) ? w.trim() : 'Go back to top';
  }
  function bridge() { return window.AGMF_PRODUCT_BRIDGE || null; }
  function column() {
    var b = bridge();
    var col = b && b.getBuyColumn ? b.getBuyColumn() : null;
    return col || document.querySelector('.agdesk-buy');
  }
  function reduced() {
    try { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { return false; }
  }

  function toTop() {
    // THE BANNER COMES BACK WITH IT (Dorian 2026-10-07: "The back to top
    // button should also show again the banner that disappears when scrolling
    // down"). agmf-desktop-header.js reads the direction from the WHEEL, so a
    // scroll made by script never told it the shopper went up; it is asked
    // directly, first, so the panes take their final height before they move.
    try {
      if (window.AGMFDesktopHeader && window.AGMFDesktopHeader.show) window.AGMFDesktopHeader.show();
    } catch (e) {}
    var how = reduced() ? 'auto' : 'smooth';
    var panes = [document.querySelector('.agdesk-media'), column()];
    panes.forEach(function (el) {
      if (!el) return;
      try { el.scrollTo({ top: 0, behavior: how }); } catch (e) { el.scrollTop = 0; }
    });
    try { window.scrollTo({ top: 0, behavior: how }); } catch (e) { window.scrollTo(0, 0); }
  }

  function style() {
    if (document.getElementById('agdesk-totop-style')) return;
    var s = document.createElement('style');
    s.id = 'agdesk-totop-style';
    s.textContent =
      // never off the desktop layout: a phone has one page and its own way up
      '.agdesk-totop{display:none}' +
      'html.agdesk-on .agdesk-totop{display:block;margin:18px 0 28px}' +
      '.agdesk-totop__btn{' +
        'display:flex;align-items:center;justify-content:center;gap:8px;width:100%;' +
        'min-height:44px;padding:0 16px;border:1px solid rgba(28,28,28,.18);border-radius:0;' +
        'background:transparent;color:#1c1c1c;cursor:pointer;font:inherit;font-size:12px;' +
        'font-weight:600;letter-spacing:.14em;text-transform:uppercase;' +
        'transition:border-color .2s,background-color .2s' +
      '}' +
      '.agdesk-totop__btn:hover{border-color:rgba(28,28,28,.55);background:rgba(28,28,28,.03)}' +
      '.agdesk-totop__btn:focus-visible{outline:2px solid #244034;outline-offset:2px}' +
      '.agdesk-totop__btn svg{width:12px;height:12px;flex:0 0 auto}';
    (document.head || root).appendChild(s);
  }

  function build() {
    style();
    wrap = document.createElement('div');
    wrap.className = 'agdesk-totop';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'agdesk-totop__btn';
    btn.setAttribute('data-agdesk-totop', '');
    btn.innerHTML = '<svg viewBox="0 0 12 12" aria-hidden="true" focusable="false">' +
      '<path d="M2 7.5 6 3.5l4 4" fill="none" stroke="currentColor" stroke-width="1.4" ' +
      'stroke-linecap="round" stroke-linejoin="round"/></svg><span></span>';
    btn.querySelector('span').textContent = label();
    btn.addEventListener('click', toTop);
    wrap.appendChild(btn);
  }

  // ALWAYS LAST in the column: anything the page appends behind it is put
  // back in front of it (the column-end Add to cart does the same, one place
  // higher - see agmf-buy-tail.js).
  function place() {
    var col = column();
    if (col !== watched) {
      if (observer) observer.disconnect();
      watched = col;
      observer = null;
      if (col) {
        observer = new MutationObserver(schedule);
        observer.observe(col, { childList: true });
      }
    }
    if (!col) return;
    if (!wrap) build();
    if (col.lastElementChild !== wrap) col.appendChild(wrap);
  }

  var pending = 0;
  function schedule() {
    if (pending) return;
    pending = setTimeout(function () { pending = 0; place(); }, 60);
  }

  function boot() {
    place();
    var b = bridge();
    if (b && b.subscribe) b.subscribe(schedule);
    // the desktop layout arrives after load and moves the column into place
    new MutationObserver(schedule).observe(root, { attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
}());
